import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "../locales/en/translation.json";
import hi from "../locales/hi/translation.json";

i18n
  .use(LanguageDetector) // auto-detect language from browser/localStorage
  .use(initReactI18next) // connect with react-i18next
  .init({
    // debug: true,
    fallbackLng: "en", // fallback if detected language is not available
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ["localStorage"], // where to detect the language
      caches: ["localStorage"], // cache user language
    },
    resources: {
      en: { translation: en },
      hi: { translation: hi },
    },
  });

export default i18n;